
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }

      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "AddressFields",
        "possibleTypes": [
          {
            "name": "Address"
          },
          {
            "name": "PostalAddress"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "AttributeValidation",
        "possibleTypes": [
          {
            "name": "AttributeValidationRegex"
          },
          {
            "name": "AttributeValidationValueAmount"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MessagingUserProfile",
        "possibleTypes": [
          {
            "name": "User"
          },
          {
            "name": "Merchant"
          },
          {
            "name": "Operator"
          },
          {
            "name": "BusinessUser"
          },
          {
            "name": "InternalMessagingUser"
          },
          {
            "name": "OnboardingSpecialistUser"
          },
          {
            "name": "SupportMessagingUser"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ExternalProfile",
        "possibleTypes": [
          {
            "name": "FacebookMessengerProfile"
          },
          {
            "name": "PiplProfile"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AttributeValue",
        "possibleTypes": [
          {
            "name": "AttributeValueInteger"
          },
          {
            "name": "AttributeValueIntegerRange"
          },
          {
            "name": "AttributeValueDecimal"
          },
          {
            "name": "AttributeValueDecimalRange"
          },
          {
            "name": "AttributeValueText"
          },
          {
            "name": "AttributeValueEnumeration"
          },
          {
            "name": "AttributeValueDate"
          },
          {
            "name": "AttributeValueDateRange"
          },
          {
            "name": "AttributeValueTime"
          },
          {
            "name": "AttributeValueTimeRange"
          },
          {
            "name": "AttributeValueDateTime"
          },
          {
            "name": "AttributeValueDateTimeRange"
          },
          {
            "name": "AttributeValueZoneId"
          },
          {
            "name": "AttributeValueId"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TextViewModel",
        "possibleTypes": [
          {
            "name": "AttributedHtmlTextViewModel"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ImageViewModel",
        "possibleTypes": [
          {
            "name": "PathImageViewModel"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "PathFlowOnComplete",
        "possibleTypes": [
          {
            "name": "PathFlowOnCompleteBroadcast"
          },
          {
            "name": "PathFlowOnCompleteLead"
          },
          {
            "name": "PathFlowOnCompleteNewPath"
          },
          {
            "name": "PathFlowOnCompleteDealRequest"
          },
          {
            "name": "PathFlowOnCompleteExpertReview"
          },
          {
            "name": "PathFlowOnCompleteRedirectOnly"
          },
          {
            "name": "PathFlowOnCompleteRedirectWithUpsert"
          },
          {
            "name": "PathFlowOnCompleteExpertApplication"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "OfferTerms",
        "possibleTypes": [
          {
            "name": "ProductOfferTerms"
          },
          {
            "name": "ServiceOfferTerms"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ReturnPolicy",
        "possibleTypes": [
          {
            "name": "NoReturnsAcceptedReturnPolicy"
          },
          {
            "name": "StandardReturnPolicy"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PaymentSource",
        "possibleTypes": [
          {
            "name": "AffirmPaymentSource"
          },
          {
            "name": "AfterpayPaymentSource"
          },
          {
            "name": "PaypalPaymentSource"
          },
          {
            "name": "StripePaymentSource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PaymentEntity",
        "possibleTypes": [
          {
            "name": "InstallmentPaymentEntity"
          },
          {
            "name": "Payment3DSecure"
          },
          {
            "name": "PaymentCard"
          },
          {
            "name": "PaypalPaymentEntity"
          },
          {
            "name": "WireTransferPaymentEntity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PaymentProcessorAccount",
        "possibleTypes": [
          {
            "name": "AffirmAccount"
          },
          {
            "name": "AfterPayAccount"
          },
          {
            "name": "PaypalAccount"
          },
          {
            "name": "StripeAccount"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "OrderLineItemSource",
        "possibleTypes": [
          {
            "name": "OrderLineItemAdHocSource"
          },
          {
            "name": "OrderLineItemBasePriceSource"
          },
          {
            "name": "OrderLineItemExpertTipSource"
          },
          {
            "name": "OrderLineItemGratuitySource"
          },
          {
            "name": "OrderLineItemSellableSource"
          },
          {
            "name": "OrderLineItemShipmentSource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SellableTerms",
        "possibleTypes": [
          {
            "name": "ServiceSellableTerms"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SellablePriceSource",
        "possibleTypes": [
          {
            "name": "AmazonSellablePriceSource"
          },
          {
            "name": "DealInventorySellablePriceSource"
          },
          {
            "name": "DealSellablePriceSource"
          },
          {
            "name": "EBaySellablePriceSource"
          },
          {
            "name": "RawSellableScraperSellablePriceSource"
          },
          {
            "name": "ScrapingSellablePriceSource"
          },
          {
            "name": "YadavSellablePriceSource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SellableSource",
        "possibleTypes": [
          {
            "name": "SellableSourceExternalId"
          },
          {
            "name": "SellableSourceStandardizedSellableGroup"
          },
          {
            "name": "SellableSourceUrl"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "EditorialReviewRating",
        "possibleTypes": [
          {
            "name": "EditorialReviewRatingFiveStar"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "DepartmentNavigationResponsiveMixin",
        "possibleTypes": [
          {
            "name": "DepartmentNavigationTopLevelItem"
          },
          {
            "name": "DepartmentNavigationExpertSubSection"
          },
          {
            "name": "DepartmentNavigationListSubSection"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "DepartmentNavigationLink",
        "possibleTypes": [
          {
            "name": "DepartmentNavigationCategoryLink"
          },
          {
            "name": "DepartmentNavigationSearchLink"
          },
          {
            "name": "DepartmentNavigationCreatePathLink"
          },
          {
            "name": "DepartmentNavigationExpertCommunityLink"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "DepartmentNavigationSubSection",
        "possibleTypes": [
          {
            "name": "DepartmentNavigationExpertSubSection"
          },
          {
            "name": "DepartmentNavigationListSubSection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "DisplayFacet",
        "possibleTypes": [
          {
            "name": "BucketedDisplayFacet"
          },
          {
            "name": "BucketedRangeDisplayFacet"
          },
          {
            "name": "NumericRangeDisplayFacet"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ExpertCuratedItemRemovedBy",
        "possibleTypes": [
          {
            "name": "User"
          },
          {
            "name": "BusinessUser"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "PromotionCreator",
        "possibleTypes": [
          {
            "name": "Operator"
          },
          {
            "name": "User"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PromotionRuleReference",
        "possibleTypes": [
          {
            "name": "OrderAmountPromotionRuleReference"
          },
          {
            "name": "PurchasedOrderCountPromotionRuleReference"
          },
          {
            "name": "SellableAttributeFilterPromotionRuleReference"
          },
          {
            "name": "SellableBrandFilterPromotionRuleReference"
          },
          {
            "name": "SellableCategoryFilterPromotionRuleReference"
          },
          {
            "name": "SellableFilterPromotionRuleReference"
          },
          {
            "name": "UserUsageLimitPromotionRuleReference"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PromotionActionReference",
        "possibleTypes": [
          {
            "name": "AmountOffOrderPromotionActionReference"
          },
          {
            "name": "PercentOffLineItemsPromotionActionReference"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "EscalationUser",
        "possibleTypes": [
          {
            "name": "User"
          },
          {
            "name": "Operator"
          },
          {
            "name": "BusinessUser"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "OrderActivityDetail",
        "possibleTypes": [
          {
            "name": "EscalationClosedActivity"
          },
          {
            "name": "MerchantClaimedActivity"
          },
          {
            "name": "OperatorAssignedActivity"
          },
          {
            "name": "OrderEscalatedActivity"
          },
          {
            "name": "OrderItemShippedActivity"
          },
          {
            "name": "ShipmentTrackingRemovedActivity"
          },
          {
            "name": "ShipmentTrackingUpdatedActivity"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "DealTerms",
        "possibleTypes": [
          {
            "name": "ProductDealTerms"
          },
          {
            "name": "ServiceDealTerms"
          },
          {
            "name": "EmptyDealTerms"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "DealCreatedByUnion",
        "possibleTypes": [
          {
            "name": "Operator"
          },
          {
            "name": "Merchant"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ExpertRecommendationRecord",
        "possibleTypes": [
          {
            "name": "ExpertRecommendationByLeastWorkloadRecord"
          },
          {
            "name": "ExpertRecommendationByPerformanceWeightRecord"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SystemCuratedItemSource",
        "possibleTypes": [
          {
            "name": "PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource"
          },
          {
            "name": "RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource"
          },
          {
            "name": "TopRecommendationAndSimilarUserSystemCuratedItemSource"
          },
          {
            "name": "TopRecommendedListSystemCuratedItemSource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "LeadActivity",
        "possibleTypes": [
          {
            "name": "ConsumerCalledActivity"
          },
          {
            "name": "ConsumerFirstMessageSentActivity"
          },
          {
            "name": "ConsumerReviewAddedActivity"
          },
          {
            "name": "DelegateExpertChangedActivity"
          },
          {
            "name": "LeadArchivedActivity"
          },
          {
            "name": "LeadEscalationChangedActivity"
          },
          {
            "name": "LeadEscalationStartedActivity"
          },
          {
            "name": "LeadOrderPaidActivity"
          },
          {
            "name": "LeadPaymentFailedActivity"
          },
          {
            "name": "LeadPaymentSucceededActivity"
          },
          {
            "name": "LeadReassignedActivity"
          },
          {
            "name": "QualityConversationEstablishedActivity"
          },
          {
            "name": "SnoozeChangedActivity"
          },
          {
            "name": "WokeUpFromSnoozeActivity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SupportTaskActivity",
        "possibleTypes": [
          {
            "name": "AssignSupportTaskActivity"
          },
          {
            "name": "DelegateLeadSupportTaskActivity"
          },
          {
            "name": "DismissSupportTaskActivity"
          },
          {
            "name": "EscalateLeadForDelegationSupportTaskActivity"
          },
          {
            "name": "EscalateLeadForReassignmentSupportTaskActivity"
          },
          {
            "name": "ReassignLeadSupportTaskActivity"
          },
          {
            "name": "RequestOrderSupportForLeadSupportTaskActivity"
          },
          {
            "name": "SnoozeSupportTaskActivity"
          },
          {
            "name": "SuggestLeadActionsSupportTaskActivity"
          },
          {
            "name": "UnassignSupportTaskActivity"
          },
          {
            "name": "UnsnoozeSupportTaskActivity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SupportTask",
        "possibleTypes": [
          {
            "name": "LeadSupportTask"
          },
          {
            "name": "OrderSupportTask"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SupportTaskActor",
        "possibleTypes": [
          {
            "name": "Operator"
          },
          {
            "name": "SystemUser"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ExpertApplicationApprover",
        "possibleTypes": [
          {
            "name": "BusinessUser"
          },
          {
            "name": "Operator"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PathFlowPageMetadata",
        "possibleTypes": [
          {
            "name": "BasicPathFlowPageMetadata"
          },
          {
            "name": "ContactPrivacyMetadata"
          },
          {
            "name": "ContactTCPAComplianceMetadata"
          },
          {
            "name": "FacebookMessengerPathFlowPageMetadata"
          },
          {
            "name": "FacebookTCPAComplianceMetadata"
          },
          {
            "name": "InterstitialPathFlowPageMetadata"
          },
          {
            "name": "PhoneExplanationModalMetadata"
          },
          {
            "name": "RatingContactPageMetadata"
          },
          {
            "name": "TermsAndConditionsPathFlowPageMetadata"
          },
          {
            "name": "TermsPrivacyMedicalPathFlowPageMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PathFlowQuestion",
        "possibleTypes": [
          {
            "name": "DatePathFlowQuestion"
          },
          {
            "name": "DateRangePathFlowQuestion"
          },
          {
            "name": "IdPathFlowQuestion"
          },
          {
            "name": "InputTextPathFlowQuestion"
          },
          {
            "name": "ListPathFlowQuestion"
          },
          {
            "name": "NumericPathFlowQuestion"
          },
          {
            "name": "OAuthEmailPathFlowQuestion"
          },
          {
            "name": "UserContactPathFlowQuestion"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "UserActivity",
        "possibleTypes": [
          {
            "name": "ViewSellableUserActivity"
          },
          {
            "name": "CheckoutStartedUserActivity"
          },
          {
            "name": "VoiceCallUserActivity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "SummarizedUserActivity",
        "possibleTypes": [
          {
            "name": "SummarizedViewSellableUserActivity"
          },
          {
            "name": "SummarizedAddSellableUserActivity"
          },
          {
            "name": "SummarizedCheckoutStartedUserActivity"
          },
          {
            "name": "SummarizedPaymentInfoEnteredUserActivity"
          },
          {
            "name": "SummarizedRemoveSellableUserActivity"
          },
          {
            "name": "SummarizedSavedSellableUserActivity"
          },
          {
            "name": "SummarizedUnSavedSellableUserActivity"
          },
          {
            "name": "SummarizedViewCartUserActivity"
          },
          {
            "name": "SummarizedViewCuratedListUserActivity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BusinessUserActivity",
        "possibleTypes": [
          {
            "name": "StartOnCallActivity"
          },
          {
            "name": "StartReceivingLeadsActivity"
          },
          {
            "name": "StopOnCallActivity"
          },
          {
            "name": "StopReceivingLeadsActivity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PayComponentRule",
        "possibleTypes": [
          {
            "name": "PayComponentCommissionRule"
          },
          {
            "name": "PayComponentFirstShiftsGuaranteedRule"
          },
          {
            "name": "PayComponentHourlyOnCallRule"
          },
          {
            "name": "PayComponentQualityConversationRule"
          },
          {
            "name": "PayComponentTipRule"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ChannelTemplate",
        "possibleTypes": [
          {
            "name": "EmailTemplate"
          },
          {
            "name": "FacebookTemplate"
          },
          {
            "name": "InAppTemplate"
          },
          {
            "name": "PushNotificationTemplate"
          },
          {
            "name": "SlackTemplate"
          },
          {
            "name": "SmsTemplate"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TemplateDataModel",
        "possibleTypes": [
          {
            "name": "TemplateCustomQueryDataModel"
          },
          {
            "name": "TemplateNamedQueryDataModel"
          },
          {
            "name": "TemplateObjectTemplateDataModel"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RenderedChannelContent",
        "possibleTypes": [
          {
            "name": "RenderedEmailContent"
          },
          {
            "name": "RenderedFacebookContent"
          },
          {
            "name": "RenderedInAppContent"
          },
          {
            "name": "RenderedPushNotificationContent"
          },
          {
            "name": "RenderedSlackContent"
          },
          {
            "name": "RenderedSmsContent"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TaskPayload",
        "possibleTypes": [
          {
            "name": "MerchantUploadTaskPayload"
          },
          {
            "name": "DealUploadTaskPayload"
          },
          {
            "name": "SellableUploadTaskPayload"
          },
          {
            "name": "SellablePriceUploadTaskPayload"
          },
          {
            "name": "BrandUploadTaskPayload"
          },
          {
            "name": "FeaturedSellableContentUploadTaskPayload"
          },
          {
            "name": "SellableUpdateTaskPayload"
          },
          {
            "name": "SellableDeactivationTaskPayload"
          },
          {
            "name": "SellableInventoryUploadTaskPayload"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CallParticipant",
        "possibleTypes": [
          {
            "name": "BusinessUser"
          },
          {
            "name": "User"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggerLiteralValue",
        "possibleTypes": [
          {
            "name": "TriggerLiteralBooleanValue"
          },
          {
            "name": "TriggerLiteralIntegerValue"
          },
          {
            "name": "TriggerLiteralStringValue"
          },
          {
            "name": "TriggerLiteralStringListValue"
          },
          {
            "name": "TriggerLiteralDateValue"
          },
          {
            "name": "TriggerLiteralIdValue"
          },
          {
            "name": "TriggerLiteralIdListValue"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TriggerNode",
        "possibleTypes": [
          {
            "name": "TriggerAction"
          },
          {
            "name": "TriggerBranch"
          },
          {
            "name": "TriggerDelay"
          },
          {
            "name": "TriggerFilter"
          },
          {
            "name": "TriggerWait"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Campaign",
        "possibleTypes": [
          {
            "name": "LeadCampaign"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SavedSearchResultConnection",
        "possibleTypes": [
          {
            "name": "LeadSearchConnection"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ContentValue",
        "possibleTypes": [
          {
            "name": "ContentBooleanValue"
          },
          {
            "name": "ContentStringValue"
          },
          {
            "name": "ContentIntValue"
          },
          {
            "name": "ContentFloatValue"
          },
          {
            "name": "ContentAsset"
          },
          {
            "name": "ContentValueArray"
          },
          {
            "name": "ContentObject"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ExpertCuratedActivityFeedItem",
        "possibleTypes": [
          {
            "name": "ExpertCuratedActivityFeedOrderItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PayComponentSummary",
        "possibleTypes": [
          {
            "name": "PayComponentCommissionSummary"
          },
          {
            "name": "PayComponentFirstShiftsGuaranteedSummary"
          },
          {
            "name": "PayComponentHourlyOnCallSummary"
          },
          {
            "name": "PayComponentManualAdjustmentSummary"
          },
          {
            "name": "PayComponentQualityConversationSummary"
          },
          {
            "name": "PayComponentTipSummary"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PayLineItemSource",
        "possibleTypes": [
          {
            "name": "PayLineItemCommissionSource"
          },
          {
            "name": "PayLineItemFirstShiftsGuaranteedSource"
          },
          {
            "name": "PayLineItemHourlyOnCallSource"
          },
          {
            "name": "PayLineItemManualAdjustmentSource"
          },
          {
            "name": "PayLineItemQualityConversationSource"
          },
          {
            "name": "PayLineItemTipSource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RawSellableSource",
        "possibleTypes": [
          {
            "name": "DealInventoryRawSellableSource"
          },
          {
            "name": "RawSellableScraperSource"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RawSellableStandardizationRuleCondition",
        "possibleTypes": [
          {
            "name": "RawSellableStandardizationRuleBinaryCondition"
          },
          {
            "name": "RawSellableStandardizationRuleConstantCondition"
          },
          {
            "name": "RawSellableStandardizationRuleLogicalCondition"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RawSellableStandardizationAction",
        "possibleTypes": [
          {
            "name": "RawSellableStandardizationCopyAttributeValueAction"
          },
          {
            "name": "RawSellableStandardizationDeactivateAction"
          },
          {
            "name": "RawSellableStandardizationHideFromConsumerSearchAction"
          },
          {
            "name": "RawSellableStandardizationMarkOutOfStockAction"
          },
          {
            "name": "RawSellableStandardizationRemoveAttributeAction"
          },
          {
            "name": "RawSellableStandardizationReplaceAttributeValueAction"
          },
          {
            "name": "RawSellableStandardizationSetAttributeValueAction"
          },
          {
            "name": "RawSellableStandardizationSetCategoryAction"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RawSellableStandardizationFieldMeta",
        "possibleTypes": [
          {
            "name": "RawSellableStandardizationAttributeValueFieldMeta"
          },
          {
            "name": "RawSellableStandardizationAttributeVariationDimensionFieldMeta"
          },
          {
            "name": "RawSellableStandardizationPredefinedFieldMeta"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SchedulingUserIdentity",
        "possibleTypes": [
          {
            "name": "Operator"
          },
          {
            "name": "BusinessUser"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ExpertNotification",
        "possibleTypes": [
          {
            "name": "ExpertNotificationLeadEscalation"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "FacetImageMetadata",
        "possibleTypes": [
          {
            "name": "BackgroundFacetImageMetadata"
          },
          {
            "name": "IconFacetImageMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "InputTextPathFlowQuestionMixin",
        "possibleTypes": [
          {
            "name": "EmbeddedInputTextPathFlowQuestion"
          },
          {
            "name": "InputTextPathFlowQuestion"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "InputTextPathFlowQuestionValidation",
        "possibleTypes": [
          {
            "name": "InputTextPathFlowQuestionLengthValidation"
          },
          {
            "name": "InputTextPathFlowQuestionNoArgValidation"
          },
          {
            "name": "InputTextPathFlowQuestionRegexValidation"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RawSellableSourceSpider",
        "possibleTypes": [
          {
            "name": "RawSellableSourceScrapinghubSpider"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "RawSellableStandardizationRuleParameter",
        "possibleTypes": [
          {
            "name": "RawSellableStandardizationRuleEntityFieldReference"
          },
          {
            "name": "RawSellableStandardizationRuleLiteralBooleanValue"
          },
          {
            "name": "RawSellableStandardizationRuleLiteralIdListValue"
          },
          {
            "name": "RawSellableStandardizationRuleLiteralIdValue"
          },
          {
            "name": "RawSellableStandardizationRuleLiteralStringListValue"
          },
          {
            "name": "RawSellableStandardizationRuleLiteralStringValue"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RenderedContent",
        "possibleTypes": [
          {
            "name": "MediaRenderedContent"
          },
          {
            "name": "TextRenderedContent"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TriggerParameter",
        "possibleTypes": [
          {
            "name": "TriggerEntityFieldReference"
          },
          {
            "name": "TriggerEventParameterReference"
          },
          {
            "name": "TriggerLiteralBooleanValue"
          },
          {
            "name": "TriggerLiteralIntegerValue"
          },
          {
            "name": "TriggerLiteralStringValue"
          },
          {
            "name": "TriggerLiteralStringListValue"
          },
          {
            "name": "TriggerLiteralDateValue"
          },
          {
            "name": "TriggerLiteralIdValue"
          },
          {
            "name": "TriggerLiteralIdListValue"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TriggerCondition",
        "possibleTypes": [
          {
            "name": "TriggerBinaryCondition"
          },
          {
            "name": "TriggerExperimentCondition"
          },
          {
            "name": "TriggerLogicalCondition"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TriggerDelayInterval",
        "possibleTypes": [
          {
            "name": "TriggerDelayFixedInterval"
          },
          {
            "name": "TriggerDelayWithExperiment"
          }
        ]
      }
    ]
  }
};

      export default result;
    